import { Membership } from 'tokyu-hooks'
import { TriplaSignInResponse } from 'tokyu-hooks/lib/response/membership'

type TriplaOpenIdSignInRequest = {
  clientSession: string
  locale: string | undefined
  openIdToken: string
}

const triplaOpenIdSignIn = async (
  request: TriplaOpenIdSignInRequest,
): Promise<TriplaSignInResponse> => {
  const response = await Membership.triplaSignIn({
    baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
    hotelCode: process.env.NEXT_PUBLIC_TRIPLA_HOTEL_CODE,
    clientSession: request.clientSession,
    locale: request.locale,
    openIdToken: request.openIdToken,
  })

  return response?.data
}

export default triplaOpenIdSignIn
